import { BlokProps } from '@/lib/types'
import { FeaturedPartnerStoryblok } from '@/lib/types/component-types-sb'
import { DynamicIconName } from '@/lib/types/icon'
import { storyblokEditable } from '@storyblok/react/rsc'
import { DynamicIcon } from 'lucide-react/dynamic'
import { Container } from '../shared/container'
import { RichText } from '../shared/rich-text'
import { SectionHeader } from '../shared/section-header'
import { StoryblokImage } from '../shared/storyblok-image'

export function FeaturedPartner({ blok }: BlokProps<FeaturedPartnerStoryblok>) {
  return (
    <section
      {...storyblokEditable(blok)}
      className="border-border border-y py-12"
    >
      <Container>
        <div className="grid grid-cols-1 items-center gap-6 lg:grid-cols-[1fr_1.75fr]">
          <div>
            <StoryblokImage
              image={blok.image}
              className="aspect-square h-auto w-full rounded-lg object-cover"
            />
          </div>
          <div className="space-y-4 lg:p-6">
            <SectionHeader
              icon={blok.descriptorIcon}
              preTitle={blok.descriptorTitle}
              title={blok.title}
            />
            <RichText content={blok.content} />
            <div className="border-border bg-sidebar flex flex-col items-start gap-4 rounded-md border p-4 lg:flex-row">
              {blok.features.map((item) => {
                return (
                  <div
                    key={item.icon}
                    className="space-y-2"
                  >
                    <DynamicIcon
                      className="text-brand"
                      size={30}
                      name={item.icon as DynamicIconName}
                    />
                    <div>
                      <span className="text-accent-foreground text-sm font-semibold">
                        {item.title}
                      </span>
                      <RichText
                        className="text-muted-foreground text-xs"
                        content={item.content}
                      ></RichText>
                    </div>
                  </div>
                )
              })}
            </div>
          </div>
        </div>
      </Container>
    </section>
  )
}
